import "./expandableConfigMod.css";
import React, { useState, useRef, useEffect, useContext } from "react";
import { Checkbox, FormControlLabel, Popover, Tooltip, } from "@mui/material";
import { Dropdowns } from "../../../../components/Dropdowns/Dropdowns";
import { AccordionComponent } from "../../../StoresModule/Components/Accordion/AccordionComponent";
import { dropdownConfig } from "../../../../services/dropdownsConfigService";
import { GlobalModal } from "../../../../components/Global Modal/GlobalModal";
import { useDropdownGlobalData } from "../../../../contexts/DropdownGlobalDataContext";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css"
import MultioptionButton from "../../../../components/Buttons/MultioptionButton";
import { deleteActiveLocation, getLocationData, updateLocation } from "../../services/locationsConfigurationService";
import { localStorageRemove, localStorageSave, localStorageGet } from "../../../../services/localStorageService";
import { environment } from "../../../../environments/environment";
import { HTTP_RESPONSE_CODES, LABELS } from "../../../../globals/globals";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import { SiteModalContent } from "../sitesModalContent/SiteModalContent";
import { setOpenLocationId } from "../../../../redux/features/configuration/locations/locationsSitesSlice";
import { useDispatch } from "react-redux";
import Input from '../../../../components/Inputs/Input';
import { LocationsContext } from "../../contexts/LocationsContext";

export const ExpandableConfigModComponent = ({ headerData, emitlocationUpdatedEvent, isDraft = false, isNewDraft = false, idx, emitLocationOpened, locationOpened, savedInBackend }) => {

  const [isOpen, setIsOpen] = useState(false); // used to open or close the expandable
  const [anchorPosition, setAnchorPosition] = useState(null);
  const [wrapperDataHubSeleceted, setwrapperDataHubSeleceted] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [typeModal, setTypeModal] = useState(null)
  const open = Boolean(anchorPosition);
  const [countryCodeSelected, setcountryCodeSelected] = useState("us")
  const { dropdownDataContext } = useDropdownGlobalData();
  const [locationInfo, setLocationInfo] = useState(null)
  const [systemOfMeasurementOptions, setSystemOfMeasurementOptions] = useState([
    {
      id: 1,
      name: "Metric",
      type: "metric"
    },
    {
      id: 2,
      name: "Imperial",
      type: "imperial"
    }
  ])

  const [systemMeasurementDrop, setSystemMeasurementDrop] = useState(null)
  const [systemMeasuremenSelected, setSystemMeasurementSelected] = useState(null)
  const [iataSelected, setiataSelected] = useState(null)
  const [locationInfoDraft, setlocationInfoDraft] = useState(null)
  const [iata_code_data, setIata_code_data] = useState(null);
  const [preSelectIataDrop, setPreselectIataDrop] = useState(null)
  const [preselectIntlSystemOfOmeasurement, setPreselectIntlSystemOfOmeasurement] = useState(null)

  const draftPrefix = "configuration/locationConfiguration/draft/location"
  const siteDraftPrefix = "configuration/locationConfiguration/draft/sites/";
  const rackDraftPrefix = "configuration/locationConfiguration/draft/racks/";
  const shelfDraftPrefix = "configuration/locationConfiguration/draft/shelves/";
  const binDraftPrefix = "configuration/locationConfiguration/draft/bins/";

  const [editionMode, seteditionMode] = useState(false)
  const [countryDropdown, setCountryDropdown] = useState(null)
  const [stateDropdown, setStateDropdown] = useState(null)
  const [cityDropdown, setCityDropdown] = useState(null)

  const [draft, setIsDraft] = useState(isDraft)
  const [childrenDraft, setChildrenDraft] = useState(false)
  const { infoMsg, successMsg, warningMsg } = useSnackBar()
  const [formErrors, setFormErrors] = useState([])

  // info of station form
  const [street1, setStreet1] = useState("")
  const [street2, setStreet2] = useState("")
  const [postalCode, setPostalCode] = useState("")
  const [email, setEmail] = useState("")
  const [preSelectCountryDrop, setPreselectCountryDrop] = useState(null)
  const [preSelectStateDrop, setPreselectStateDrop] = useState(null)
  const [preSelectCityDrop, setPreselectCityDrop] = useState(null)
  const [stationPhone, setStationPhone] = useState("")

  // info of finance and billing form

  const [street1Finance, setStreet1Finance] = useState("")
  const [street2Finance, setStreet2Finance] = useState("")
  const [postalCodeFinance, setPostalCodeFinance] = useState("")
  const [emailFinance, setEmailFinance] = useState("")
  const [preSelectCountryDropFinance, setPreselectCountryDropFinance] = useState(null)
  const [preSelectStateDropFinance, setPreselectStateDropFinance] = useState(null)
  const [preSelectCityDropFinance, setPreselectCityDropFinance] = useState(null)
  const [financePhone, setFinancePhone] = useState()

  // Info of AOG and billing form

  const [street1AOG, setStreet1AOG] = useState("");
  const [street2AOG, setStreet2AOG] = useState("");
  const [postalCodeAOG, setPostalCodeAOG] = useState("");
  const [emailAOG, setEmailAOG] = useState("");
  const [preSelectCountryDropAOG, setPreselectCountryDropAOG] = useState(null);
  const [preSelectStateDropAOG, setPreselectStateDropAOG] = useState(null);
  const [preSelectCityDropAOG, setPreselectCityDropAOG] = useState(null);
  const [AOGPhone, setAOGPhone] = useState();

  // Info of Critical and billing form

  const [street1Critical, setStreet1Critical] = useState("");
  const [street2Critical, setStreet2Critical] = useState("");
  const [postalCodeCritical, setPostalCodeCritical] = useState("");
  const [emailCritical, setEmailCritical] = useState("");
  const [preSelectCountryDropCritical, setPreselectCountryDropCritical] = useState(null);
  const [preSelectStateDropCritical, setPreselectStateDropCritical] = useState(null);
  const [preSelectCityDropCritical, setPreselectCityDropCritical] = useState(null);
  const [CriticalPhone, setCriticalPhone] = useState();

  // Info of whareHouse and billing form

  const [street1whareHouse, setStreet1whareHouse] = useState("");
  const [street2whareHouse, setStreet2whareHouse] = useState("");
  const [postalCodewhareHouse, setPostalCodewhareHouse] = useState("");
  const [emailwhareHouse, setEmailwhareHouse] = useState("");
  const [preSelectCountryDropwhareHouse, setPreselectCountryDropwhareHouse] = useState(null);
  const [preSelectStateDropwhareHouse, setPreselectStateDropwhareHouse] = useState(null);
  const [preSelectCityDropwhareHouse, setPreselectCityDropwhareHouse] = useState(null);
  const [whareHousePhone, setwhareHousePhone] = useState();
  const { draftStatusChanged } = useContext(LocationsContext)

  const dispatch = useDispatch();

  // functions
  const handleContextMenu = (e) => {
    e.preventDefault();

    if (savedInBackend) {
      if (headerData.intMeasurementSystem === null) {
        infoMsg("Cannot Open", "No measurement System selected. Please select a measurement system before proceeding.", 5000);
      } else {
        setAnchorPosition({
          top: e.clientY,
          left: e.clientX,
        });
        dispatch(setOpenLocationId(headerData.id));
      }
    } else {
      infoMsg(
        "Cannot Open",
        "This location has only been created locally. Please save the information to access the sites configuration.",
        5000
      );
    }

  };

  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorPosition(null);
  };

  const handleWrapperDataHubSeleceted = () => {
    setwrapperDataHubSeleceted(!wrapperDataHubSeleceted);
  };

  const toggleExpandable = () => {
    if (!openModal) {
      setIsOpen((prevState) => {
        if (prevState == false) {
          return true
        } else {
          return false
        }
      });
    }
  };

  const getIataCodeDropdownConfig = async () => {
    let dropdownId = 24;
    const request = await dropdownConfig(dropdownId);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setIata_code_data(request.data.load)
    }
  }

  const getStationDropdownCountry = async () => {
    const id = 25;
    const response = await dropdownConfig(id);
    if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setCountryDropdown(response.data.load)
    }
    return null;
  };

  const getStationDropdownState = async () => {
    const id = 26;
    const response = await dropdownConfig(id);
    if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setStateDropdown(response.data.load)
    }
    return null;
  };

  const getStationDropdownCity = async () => {
    const id = 28;
    const response = await dropdownConfig(id);
    if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setCityDropdown(response.data.load)
    }
    return null;
  };


  const getAllStationDropdownConfigs = async () => {
    const results = await Promise.all([
      getStationDropdownCountry(),
      getStationDropdownState(),
      getStationDropdownCity()
    ]);

    return results;
  };


  const openSitesConfigModal = () => {
    setTypeModal("sites")
    setOpenModal(true)
  }

  const closeSitesConfigModal = () => {
    setOpenModal(false)
  }

  // dropdowns of station

  const handleCountryDropSelected = (data) => {
    setPreselectCountryDrop(data.id)
    setcountryCodeSelected(data.code.toLowerCase())
    setPreselectStateDrop(null);
    setPreselectCityDrop(null)
  }

  const handleStateDropSelected = (data) => {
    setPreselectStateDrop(data.id)
    setPreselectCityDrop(null)


  }

  const handleCityDropSelected = (data) => {
    setPreselectCityDrop(data.id)

  }


  // dropdowns of finance and billing
  const handleCountryDropSelectedFinance = (data) => {

    setPreselectCountryDropFinance(data.id)

  }

  const handleStateDropSelectedFinance = (data) => {

    setPreselectStateDropFinance(data.id)

  }

  const handleCityDropSelectedFinance = (data) => {

    setPreselectCityDropFinance(data.id)

  }

  // Dropdowns of AOG and billing
  const handleCountryDropSelectedAOG = (data) => {
    setPreselectCountryDropAOG(data.id);
  };

  const handleStateDropSelectedAOG = (data) => {
    setPreselectStateDropAOG(data.id);
  };

  const handleCityDropSelectedAOG = (data) => {
    setPreselectCityDropAOG(data.id);
  };

  // Dropdowns of Critical and billing
  const handleCountryDropSelectedCritical = (data) => {
    setPreselectCountryDropCritical(data.id);
  };

  const handleStateDropSelectedCritical = (data) => {
    setPreselectStateDropCritical(data.id);
  };

  const handleCityDropSelectedCritical = (data) => {
    setPreselectCityDropCritical(data.id);
  };

  // Dropdowns of whareHouse and billing

  const handleCountryDropSelectedwhareHouse = (data) => {
    setPreselectCountryDropwhareHouse(data.id);
  };

  const handleStateDropSelectedwhareHouse = (data) => {
    setPreselectStateDropwhareHouse(data.id);
  };

  const handleCityDropSelectedwhareHouse = (data) => {
    setPreselectCityDropwhareHouse(data.id);
  };

  // dropdown of system of measurement

  const getSystemOfMeasurementDropdownConfig = async () => {
    let dropdownId = 49;
    const request = await dropdownConfig(dropdownId);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setSystemMeasurementDrop(request.data.load)
    }
  }

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    let setDropdown;

    switch (dropdownId) {
      case 25:
        setDropdown = setCountryDropdown;
        break;
      case 26:
        setDropdown = setStateDropdown;
        break;
      case 28:
        setDropdown = setCityDropdown;
        break;
      default:
        return;
    }

    const debounceUpdate = setTimeout(() => {
      setDropdown((prevState) => ({
        ...prevState,
        parentValues,
        dependenciesToUpdate,
        reload: true,
      }));
    }, 200);

    return () => clearTimeout(debounceUpdate);
  };


  const resetDropdownsReload = () => {
    setCountryDropdown((prevState) => ({ ...prevState, reload: false }));
    setStateDropdown((prevState) => ({ ...prevState, reload: false }));
    setCityDropdown((prevState) => ({ ...prevState, reload: false }));
  };

  const updateDropdownFinance = (dropdownId, parentValues, dependenciesToUpdate) => {
    let setDropdown;

    switch (dropdownId) {
      case 25:
        setDropdown = setCountryDropdown;
        break;
      case 26:
        setDropdown = setStateDropdown;
        break;
      case 28:
        setDropdown = setCityDropdown;
        break;
      default:
        return;
    }

    const debounceUpdate = setTimeout(() => {
      setDropdown((prevState) => ({
        ...prevState,
        parentValues,
        dependenciesToUpdate,
        reload: true,
      }));
    }, 200);

    return () => clearTimeout(debounceUpdate);
  };

  const resetDropdownsReloadFinance = () => {
    setCountryDropdown((prevState) => ({ ...prevState, reload: false }));
    setStateDropdown((prevState) => ({ ...prevState, reload: false }));
    setCityDropdown((prevState) => ({ ...prevState, reload: false }));
  };


  const updateDropdownAOG = (dropdownId, parentValues, dependenciesToUpdate) => {
    let setDropdown;

    switch (dropdownId) {
      case 25:
        setDropdown = setCountryDropdown;
        break;
      case 26:
        setDropdown = setStateDropdown;
        break;
      case 28:
        setDropdown = setCityDropdown;
        break;
      default:
        return;
    }

    const debounceUpdate = setTimeout(() => {
      setDropdown((prevState) => ({
        ...prevState,
        parentValues,
        dependenciesToUpdate,
        reload: true,
      }));
    }, 200);

    return () => clearTimeout(debounceUpdate);
  };

  const resetDropdownsReloadAOG = () => {
    setCountryDropdown((prevState) => ({ ...prevState, reload: false }));
    setStateDropdown((prevState) => ({ ...prevState, reload: false }));
    setCityDropdown((prevState) => ({ ...prevState, reload: false }));
  };


  const updateDropdownCritical = (dropdownId, parentValues, dependenciesToUpdate) => {
    let setDropdown;

    switch (dropdownId) {
      case 25:
        setDropdown = setCountryDropdown;
        break;
      case 26:
        setDropdown = setStateDropdown;
        break;
      case 28:
        setDropdown = setCityDropdown;
        break;
      default:
        return;
    }

    const debounceUpdate = setTimeout(() => {
      setDropdown((prevState) => ({
        ...prevState,
        parentValues,
        dependenciesToUpdate,
        reload: true,
      }));
    }, 200);

    return () => clearTimeout(debounceUpdate);
  };

  const resetDropdownsReloadCritical = () => {
    setCountryDropdown((prevState) => ({ ...prevState, reload: false }));
    setStateDropdown((prevState) => ({ ...prevState, reload: false }));
    setCityDropdown((prevState) => ({ ...prevState, reload: false }));
  };

  const updateDropdownWhareHouse = (dropdownId, parentValues, dependenciesToUpdate) => {
    let setDropdown;

    switch (dropdownId) {
      case 25:
        setDropdown = setCountryDropdown;
        break;
      case 26:
        setDropdown = setStateDropdown;
        break;
      case 28:
        setDropdown = setCityDropdown;
        break;
      default:
        return;
    }

    const debounceUpdate = setTimeout(() => {
      setDropdown((prevState) => ({
        ...prevState,
        parentValues,
        dependenciesToUpdate,
        reload: true,
      }));
    }, 200);

    return () => clearTimeout(debounceUpdate);
  };

  const resetDropdownsReloadWharehouse = () => {
    setCountryDropdown((prevState) => ({ ...prevState, reload: false }));
    setStateDropdown((prevState) => ({ ...prevState, reload: false }));
    setCityDropdown((prevState) => ({ ...prevState, reload: false }));
  };

  const getCountryCode = () => {
    dropdownDataContext.map((dropdown) => {
      if (dropdown.dropdownId == 25) {
        setcountryCodeSelected(dropdown?.ValuesSelected[0].code.toLowerCase())
      }
    })
  }

  const updateLocationData = async (body, typeOfFinish = "") => {

    if (typeOfFinish == "continue") {

      if (!validateStationForm()) {
        return;
      }

      const request = await updateLocation(body)
      if (request.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
        preLoadForm(request.data.load)
        successMsg("Saved successfully", "The Location has been saved successfully.")
        localStorageRemove(draftPrefix, { locationId: request.data.load.id.toString() })
        setLocationInfo(request.data.load)
        setIsDraft(false)
        // if (emitlocationUpdatedEvent) {
        //   emitlocationUpdatedEvent()
        // }
        seteditionMode(true)
        setIsDraft(false)
      }

    } else {

      if (!validateStationForm()) {
        return;
      }
      const request = await updateLocation(body)
      if (request.data.responseCode == HTTP_RESPONSE_CODES.UPDATED) {

        preLoadForm(request.data.load)
        localStorageRemove(draftPrefix, { locationId: locationInfoDraft.id.toString() })
        setLocationInfo(request.data.load)
        successMsg("Saved Succesfully", "The Location has been saved successfully.")
        seteditionMode(false)
        setIsDraft(false)
        setIsOpen(false)
        if (emitlocationUpdatedEvent) {
          emitlocationUpdatedEvent(headerData.id)
        }
      }

    }
  }

  const cancelUpdateLocation = (data) => {

    try {

      successMsg("Changes Discarded", "Changes Discarded Successfully")
      localStorageRemove(draftPrefix, { locationId: data.id.toString() })
      setFormErrors([])
      preLoadForm(locationInfo)
      if (emitlocationUpdatedEvent) {
        emitlocationUpdatedEvent()
      }
      seteditionMode(false)
      setIsDraft(false)
      setIsOpen(false)
    } catch (error) {
      console.error("error : ", error)
      warningMsg("Error", "Something went wrong while performing this action")
    }


  }

  const getLocationInfo = async () => {
    const locationId = headerData.id;

    const request = await getLocationData(locationId);

    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      const locationInDraft = localStorageGet(draftPrefix, { locationId: locationId.toString() })

      setLocationInfo(() => {
        const updatedData = request.data.load;
        locationInDraft.length > 0 ? preLoadForm(locationInDraft[0]) : preLoadForm(updatedData)
        return updatedData
      })
    }
  }

  const preLoadForm = (data) => {
    // station data
    setStreet1(data.contactInformation?.[0]?.contactInformation?.street1 ? data.contactInformation?.[0]?.contactInformation?.street1 : "")
    setStreet2(data.contactInformation?.[0]?.contactInformation?.street2 ? data.contactInformation?.[0]?.contactInformation?.street2 : "")
    setPostalCode(data.contactInformation?.[0]?.contactInformation?.postalCode ? data.contactInformation?.[0]?.contactInformation?.postalCode : "");
    setStationPhone(data.contactInformation?.[0]?.contactInformation?.phoneNumber ? data.contactInformation?.[0]?.contactInformation?.phoneNumber : "")
    setPreselectCountryDrop(data.contactInformation?.[0]?.contactInformation?.countryId ? data.contactInformation?.[0]?.contactInformation?.countryId : "")
    setPreselectStateDrop(data.contactInformation?.[0]?.contactInformation?.stateId ? data.contactInformation?.[0]?.contactInformation?.stateId : "")
    setPreselectCityDrop(data.contactInformation?.[0]?.contactInformation?.cityId ? data.contactInformation?.[0]?.contactInformation?.cityId : "")
    setEmail(data.contactInformation?.[0]?.contactInformation?.email ? data.contactInformation?.[0]?.contactInformation?.email : "")

    // finance and billing data
    setStreet1Finance(data.contactInformation?.[1]?.contactInformation?.street1 ? data.contactInformation?.[1]?.contactInformation?.street1 : "")
    setStreet2Finance(data.contactInformation?.[1]?.contactInformation?.street2 ? data.contactInformation?.[1]?.contactInformation?.street2 : "")
    setFinancePhone(data.contactInformation?.[1]?.contactInformation?.phoneNumber ? data.contactInformation?.[1]?.contactInformation?.phoneNumber : "")
    setPreselectCountryDropFinance(data.contactInformation?.[1]?.contactInformation?.countryId ? data.contactInformation?.[1]?.contactInformation?.countryId : "")
    setPreselectStateDropFinance(data.contactInformation?.[1]?.contactInformation?.stateId ? data.contactInformation?.[1]?.contactInformation?.stateId : "")
    setPreselectCityDropFinance(data.contactInformation?.[1]?.contactInformation?.cityId ? data.contactInformation?.[1]?.contactInformation?.cityId : "")
    setPostalCodeFinance(data.contactInformation?.[1]?.contactInformation?.postalCode ? data.contactInformation?.[1]?.contactInformation?.postalCode : "");
    setEmailFinance(data.contactInformation?.[1]?.contactInformation?.email ? data.contactInformation?.[1]?.contactInformation?.email : "")

    // AOG and billing data
    setStreet1AOG(data.contactInformation?.[2]?.contactInformation?.street1 ? data.contactInformation?.[2]?.contactInformation?.street1 : "");
    setStreet2AOG(data.contactInformation?.[2]?.contactInformation?.street2 ? data.contactInformation?.[2]?.contactInformation?.street2 : "");
    setAOGPhone(data.contactInformation?.[2]?.contactInformation?.phoneNumber ? data.contactInformation?.[2]?.contactInformation?.phoneNumber : "");
    setPreselectCountryDropAOG(data.contactInformation?.[2]?.contactInformation?.countryId ? data.contactInformation?.[2]?.contactInformation?.countryId : "");
    setPreselectStateDropAOG(data.contactInformation?.[2]?.contactInformation?.stateId ? data.contactInformation?.[2]?.contactInformation?.stateId : "");
    setPreselectCityDropAOG(data.contactInformation?.[2]?.contactInformation?.cityId ? data.contactInformation?.[2]?.contactInformation?.cityId : "");
    setPostalCodeAOG(data.contactInformation?.[2]?.contactInformation?.postalCode ? data.contactInformation?.[2]?.contactInformation?.postalCode : "");
    setEmailAOG(data.contactInformation?.[2]?.contactInformation?.email ? data.contactInformation?.[2]?.contactInformation?.email : "");

    // Critical and billing data
    setStreet1Critical(data.contactInformation?.[3]?.contactInformation?.street1 ? data.contactInformation?.[3]?.contactInformation?.street1 : "");
    setStreet2Critical(data.contactInformation?.[3]?.contactInformation?.street2 ? data.contactInformation?.[3]?.contactInformation?.street2 : "");
    setCriticalPhone(data.contactInformation?.[3]?.contactInformation?.phoneNumber ? data.contactInformation?.[3]?.contactInformation?.phoneNumber : "");
    setPreselectCountryDropCritical(data.contactInformation?.[3]?.contactInformation?.countryId ? data.contactInformation?.[3]?.contactInformation?.countryId : "");
    setPreselectStateDropCritical(data.contactInformation?.[3]?.contactInformation?.stateId ? data.contactInformation?.[3]?.contactInformation?.stateId : "");
    setPreselectCityDropCritical(data.contactInformation?.[3]?.contactInformation?.cityId ? data.contactInformation?.[3]?.contactInformation?.cityId : "");
    setPostalCodeCritical(data.contactInformation?.[3]?.contactInformation?.postalCode ? data.contactInformation?.[3]?.contactInformation?.postalCode : "");
    setEmailCritical(data.contactInformation?.[3]?.contactInformation?.email ? data.contactInformation?.[3]?.contactInformation?.email : "");


    // whareHouse and billing data
    setStreet1whareHouse(data.contactInformation?.[4]?.contactInformation?.street1 ? data.contactInformation?.[4]?.contactInformation?.street1 : "");
    setStreet2whareHouse(data.contactInformation?.[4]?.contactInformation?.street2 ? data.contactInformation?.[4]?.contactInformation?.street2 : "");
    setwhareHousePhone(data.contactInformation?.[4]?.contactInformation?.phoneNumber ? data.contactInformation?.[4]?.contactInformation?.phoneNumber : "");
    setPreselectCountryDropwhareHouse(data.contactInformation?.[4]?.contactInformation?.countryId ? data.contactInformation?.[4]?.contactInformation?.countryId : "");
    setPreselectStateDropwhareHouse(data.contactInformation?.[4]?.contactInformation?.stateId ? data.contactInformation?.[4]?.contactInformation?.stateId : "");
    setPreselectCityDropwhareHouse(data.contactInformation?.[4]?.contactInformation?.cityId ? data.contactInformation?.[4]?.contactInformation?.cityId : "");
    setPostalCodewhareHouse(data.contactInformation?.[4]?.contactInformation?.postalCode ? data.contactInformation?.[4]?.contactInformation?.postalCode : "");
    setEmailwhareHouse(data.contactInformation?.[4]?.contactInformation?.email ? data.contactInformation?.[4]?.contactInformation?.email : "");


    setPreselectIataDrop(data.code ? data.code : null)
    setPreselectIntlSystemOfOmeasurement(data.intMeasurementSystem ? data.intMeasurementSystem : null)
    setSystemMeasurementSelected(data.intMeasurementSystem ? data.intMeasurementSystem : null)
    setiataSelected(data.code ? { standard_code: data.code, name: data.name, timezone_id: data.timezone } : null)
  }

  const deleteThisLocation = async () => {
    const locationId = headerData.id;
    const request = await deleteActiveLocation(locationId);
    if (request.data.responseCode == HTTP_RESPONSE_CODES.DELETED) {

      successMsg("Location Deleted", "Location Deleted Successfully")
      setOpenModal(false)
      localStorageRemove(draftPrefix, { locationId: headerData.id.toString() })
      if (emitlocationUpdatedEvent) {
        emitlocationUpdatedEvent(headerData.id)
      }
    }
  }

  const saveInDraft = () => {
    if (locationInfoDraft !== null) {
      localStorageSave(draftPrefix, { locationId: headerData?.id.toString() }, locationInfoDraft)
      setIsDraft(true)
      seteditionMode(true)
    }
  }

  const deleteErrorInForm = (e) => {
    setFormErrors((prevArray) => {
      const modArray = [...prevArray];
      const index = modArray.indexOf(e);

      if (index !== -1) {
        modArray.splice(index, 1);
      }

      return modArray;
    });
  }

  const validateStationForm = () => {

    setFormErrors([]);

    let hasErrors = false;

    if (iataSelected == null || iataSelected == undefined) {
      infoMsg("Please select an IATA code");
      hasErrors = true;
    }

    if (street1 == null || street1 == undefined || street1 == "") {
      infoMsg("Please fill the street 1 field in the station section");
      setFormErrors((prevState) => [...prevState, "street1"]);
      hasErrors = true;
    }

    if (preSelectCountryDrop == null || preSelectCountryDrop == undefined || preSelectCountryDrop == "") {
      infoMsg("Please select a country in the station section");
      setFormErrors((prevState) => [...prevState, "preselectCountry"]);
      hasErrors = true;
    }

    if (preSelectStateDrop == null || preSelectStateDrop == undefined || preSelectStateDrop == "") {
      infoMsg("Please select a state in the station section");
      setFormErrors((prevState) => [...prevState, "preselectState"]);
      hasErrors = true;
    }

    if (preSelectCityDrop == null || preSelectCityDrop == undefined || preSelectCityDrop == "") {
      infoMsg("Please select a city in the station section");
      setFormErrors((prevState) => [...prevState, "preselectCity"]);
      hasErrors = true;
    }

    if (postalCode == null || postalCode == undefined || postalCode == "") {
      infoMsg("Please enter a postal code in the station section");
      setFormErrors((prevState) => [...prevState, "postalCode"]);
      hasErrors = true;
    }

    if (email !== undefined && email !== null && email !== "") {
      if (!environment.emailRegexPattern.test(email)) {
        infoMsg("Please enter a valid email in the station section");
        setFormErrors((prevState) => [...prevState, "email"]);
        hasErrors = true;
      }
    }

    return !hasErrors;
  };


  //  useEffects

  useEffect(() => {
    if (locationOpened !== idx) {
      setIsOpen(false)
    }
  }, [locationOpened])

  useEffect(() => {
    if (isOpen && !iata_code_data) {
      getIataCodeDropdownConfig()
    }

    setTimeout(() => {
      if (isOpen && !countryDropdown && !stateDropdown && !cityDropdown) {
        getAllStationDropdownConfigs()
      }
    }, 500)

    if (isOpen && !systemMeasurementDrop) {
      getSystemOfMeasurementDropdownConfig()
    }

    if (isOpen) {
      // getCountryCode()
    }

    if (isOpen && !locationInfo) {
      getLocationInfo()
    }

  }, [isOpen, dropdownDataContext])

  useEffect(() => {
    if (isOpen) {
      saveInDraft()
    }
  }, [locationInfoDraft])

  useEffect(() => {
    validateChildDraftStatus()
  }, [draftStatusChanged])

  useEffect(() => {
    if (editionMode) {
      setlocationInfoDraft(() => {
        const updatedData = {
          version: locationInfo?.version,
          id: headerData?.id,
          accountId: parseInt(localStorage.getItem("u_account_id")),
          code: iataSelected?.standard_code,
          name: iataSelected?.name,
          timezone: iataSelected?.timezone_id,
          intMeasurementSystem: systemMeasuremenSelected,
          active: true,
          locationTypeId: 0,
          "status": null,

          contactInformation: [
            {//station Info data
              version: locationInfo?.contactInformation ? locationInfo?.contactInformation[0]?.version : null,
              id: locationInfo?.contactInformation ? locationInfo?.contactInformation[0]?.id : null,
              locationId: locationInfo?.id,
              contactInformation: {
                version: locationInfo?.contactInformation ? locationInfo?.contactInformation[0]?.contactInformation?.version : null,
                id: locationInfo?.contactInformation ? locationInfo?.contactInformation[0]?.contactInformation?.id : null,
                street1: street1,
                street2: street2,
                countryId: preSelectCountryDrop,
                stateId: preSelectStateDrop,
                cityId: preSelectCityDrop,
                postalCode: postalCode,
                email: email,
                phoneNumber: stationPhone,
              },
              departmentAreaId: 1,
            },

            {//finance Info data
              version: locationInfo?.contactInformation ? locationInfo?.contactInformation[1]?.version : null,
              id: locationInfo?.contactInformation ? locationInfo?.contactInformation[1]?.id : null,
              locationId: locationInfo?.id,
              contactInformation: {
                version: locationInfo?.contactInformation ? locationInfo?.contactInformation[1]?.contactInformation?.version : null,
                id: locationInfo?.contactInformation ? locationInfo?.contactInformation[1]?.contactInformation?.id : null,
                street1: street1Finance,
                street2: street2Finance,
                countryId: preSelectCountryDropFinance,
                stateId: preSelectStateDropFinance,
                cityId: preSelectCityDropFinance,
                postalCode: postalCodeFinance,
                email: emailFinance,
                phoneNumber: financePhone,
              },
              departmentAreaId: 2,
            },
            {// AOG Info data
              version: locationInfo?.contactInformation ? locationInfo?.contactInformation[2]?.version : null,
              id: locationInfo?.contactInformation ? locationInfo?.contactInformation[2]?.id : null,
              locationId: locationInfo?.id,
              contactInformation: {
                version: locationInfo?.contactInformation ? locationInfo?.contactInformation[2]?.contactInformation?.version : null,
                id: locationInfo?.contactInformation ? locationInfo?.contactInformation[2]?.contactInformation?.id : null,
                street1: street1AOG,
                street2: street2AOG,
                countryId: preSelectCountryDropAOG,
                stateId: preSelectStateDropAOG,
                cityId: preSelectCityDropAOG,
                postalCode: postalCodeAOG,
                email: emailAOG,
                phoneNumber: AOGPhone,
              },
              departmentAreaId: 3,
            },

            {// Critical Info data
              version: locationInfo?.contactInformation ? locationInfo?.contactInformation[3]?.version : null,
              id: locationInfo?.contactInformation ? locationInfo?.contactInformation[3]?.id : null,
              locationId: locationInfo?.id,
              contactInformation: {
                version: locationInfo?.contactInformation ? locationInfo?.contactInformation[3]?.contactInformation?.version : null,
                id: locationInfo?.contactInformation ? locationInfo?.contactInformation[3]?.contactInformation?.id : null,
                street1: street1Critical,
                street2: street2Critical,
                countryId: preSelectCountryDropCritical,
                stateId: preSelectStateDropCritical,
                cityId: preSelectCityDropCritical,
                postalCode: postalCodeCritical,
                email: emailCritical,
                phoneNumber: CriticalPhone,
              },
              departmentAreaId: 4,
            },

            {
              // whareHouse Info data
              version: locationInfo?.contactInformation ? locationInfo?.contactInformation[4]?.version : null,
              id: locationInfo?.contactInformation ? locationInfo?.contactInformation[4]?.id : null,
              locationId: locationInfo?.id,
              contactInformation: {
                version: locationInfo?.contactInformation ? locationInfo?.contactInformation[4]?.contactInformation?.version : null,
                id: locationInfo?.contactInformation ? locationInfo?.contactInformation[4]?.contactInformation?.id : null,
                street1: street1whareHouse,
                street2: street2whareHouse,
                countryId: preSelectCountryDropwhareHouse,
                stateId: preSelectStateDropwhareHouse,
                cityId: preSelectCityDropwhareHouse,
                postalCode: postalCodewhareHouse,
                email: emailwhareHouse,
                phoneNumber: whareHousePhone,
              },
              departmentAreaId: 5,
            }

          ]
        }


        return updatedData
      })
    }

  },
    [
      iataSelected,
      systemMeasuremenSelected,
      preSelectCountryDrop,
      preSelectStateDrop,
      preSelectCityDrop,
      stationPhone,
      street1,
      street2,
      postalCode,
      email,
      preSelectCountryDropFinance,
      preSelectStateDropFinance,
      preSelectCityDropFinance,
      street1Finance,
      street2Finance,
      postalCodeFinance,
      emailFinance,
      financePhone,
      preSelectCountryDropAOG,
      preSelectStateDropAOG,
      preSelectCityDropAOG,
      street1AOG,
      street2AOG,
      postalCodeAOG,
      emailAOG,
      AOGPhone,
      preSelectCountryDropCritical,
      preSelectStateDropCritical,
      preSelectCityDropCritical,
      street1Critical,
      street2Critical,
      postalCodeCritical,
      emailCritical,
      CriticalPhone,
      preSelectCountryDropwhareHouse,
      preSelectStateDropwhareHouse,
      preSelectCityDropwhareHouse,
      street1whareHouse,
      street2whareHouse,
      postalCodewhareHouse,
      emailwhareHouse,
      whareHousePhone,
      editionMode])


  const validateChildDraftStatus = () => {
    let hasSiteDraft = localStorageGet(siteDraftPrefix, { locationId: headerData.id })
    let hasRacksDrafts = localStorageGet(rackDraftPrefix, { locationId: headerData.id })
    let hasShelvesDrafts = localStorageGet(shelfDraftPrefix, { locationId: headerData.id })
    let hasBinsDraft = localStorageGet(binDraftPrefix, { locationId: headerData.id })


    const hasAnyChildrenDraft = (
      (hasRacksDrafts?.length || 0) > 0 ||
      (hasShelvesDrafts?.length || 0) > 0 ||
      (hasBinsDraft?.length || 0) > 0 ||
      (hasSiteDraft?.length || 0) > 0
    );

    setChildrenDraft(hasAnyChildrenDraft);
  };

  useEffect(() => {

    validateChildDraftStatus()
    if (isNewDraft) {
      seteditionMode(true)
      setIsOpen(true)
    } else {
      seteditionMode(false)
    }

    if (isDraft) {
      // seteditionMode(true)
    }


  }, [])

  const multiOptionsBtn = [
    { label: 'Save and Finish', icon: "icon-save", id: 'save' },
    { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
    { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
  ];

  const buttonsCallback = {
    "save": () => updateLocationData(locationInfoDraft, "finish"),
    "save-continue": () => updateLocationData(locationInfoDraft, "continue"),
    "cancel": () => cancelUpdateLocation(locationInfoDraft),
  }

  // calback to dropdowns 

  const getIataSelection = (data) => {
    setTimeout(() => {
      setiataSelected(data)
      // station data
      setPreselectCountryDrop(data.country_id)
      setPreselectStateDrop(data.state_id)
      setPreselectCityDrop(data.city_id)


      setPreselectIataDrop(data.standard_code)
    }, 200)

  }

  const getSystemMeasurementSelection = (data) => {
    setSystemMeasurementSelected(data.type)
  }

  const countryRef = useRef(null)
  const stateRef = useRef(null)
  const cityRef = useRef(null)

  useEffect(() => {
    if (countryRef.current && stateRef.current && cityRef.current) {
      setPreselectCityDrop(null)
      setPreselectStateDrop(null)
      stateRef.current.clearAllFilters()
      cityRef.current.clearAllFilters()
    }

  }, [preSelectCountryDrop])

  useEffect(() => {
    if (countryRef.current && stateRef.current && cityRef.current) {
      setPreselectCityDrop(null)
      // setPreselectStateDrop(null)
      // stateRef.current.clearAllFilters()
      cityRef.current.clearAllFilters()
    }

  }, [preSelectStateDrop])

  return (
    <>
      <section
        onClick={() => {
          emitLocationOpened(idx)
          toggleExpandable()
        }}
        onContextMenu={handleContextMenu}
        className={`${isOpen
          ? "expandable-configMod-header-opened"
          : "expandable-configMod-header"
          }`}
        tabIndex={0}

        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            emitLocationOpened(idx)
            toggleExpandable()
          }
        }}
      >
        {(draft || childrenDraft) && (<span className="draft-location-span">{LABELS.DRAFT}</span>)}
        <Popover
          open={open}
          anchorReference="anchorPosition"
          anchorPosition={
            anchorPosition
              ? { top: anchorPosition.top, left: anchorPosition.left }
              : undefined
          }
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <div className="expandable-popOver-option-cont">
            <span onClick={(e) => {
              e.stopPropagation()
              handleClose(e)
              openSitesConfigModal()
            }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="20.582"
                height="21.386"
                viewBox="0 0 20.582 21.386"
                className="custom-svg"
              >
                <defs>
                  <clipPath id="clip-path">
                    <rect
                      id="Rectangle_1399"
                      data-name="Rectangle 1399"
                      width="20.582"
                      height="21.386"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Group_2653"
                  data-name="Group 2653"
                  clipPath="url(#clip-path)"
                >
                  <path
                    id="Path_1250"
                    data-name="Path 1250"
                    d="M78.081,79.9a2.271,2.271,0,1,0-2.271-2.271A2.273,2.273,0,0,0,78.081,79.9m0-2.954a.683.683,0,1,1-.683.683.684.684,0,0,1,.683-.683"
                    transform="translate(-72.644 -72.212)"
                  />
                  <path
                    id="Path_1251"
                    data-name="Path 1251"
                    d="M20.217,7.153a5.652,5.652,0,0,0-4.389-4.389h-.008A28.855,28.855,0,0,0,11.087,2.4c-.383,0-.761.007-1.13.019A5.429,5.429,0,0,0,5.442,0h-.01A5.438,5.438,0,0,0,0,5.432,7.621,7.621,0,0,0,1.662,9.775c-.044.677-.066,1.387-.067,2.118a28.826,28.826,0,0,0,.364,4.73v.008A5.652,5.652,0,0,0,6.35,21.02h.008a28.855,28.855,0,0,0,4.732.364,28.84,28.84,0,0,0,4.73-.364h.008a5.652,5.652,0,0,0,4.389-4.389v-.008a28.847,28.847,0,0,0,.364-4.732,28.847,28.847,0,0,0-.364-4.73V7.153ZM5.432,1.587h.01A3.849,3.849,0,0,1,9.287,5.432,6.236,6.236,0,0,1,7.777,9.043,8.19,8.19,0,0,1,5.44,11.171a8.143,8.143,0,0,1-2.3-2.079.787.787,0,0,0-.078-.1,6.182,6.182,0,0,1-1.472-3.56A3.849,3.849,0,0,1,5.432,1.587ZM3.186,11.469a6.831,6.831,0,0,0,1.743,1.216,1.282,1.282,0,0,0,1.02,0,9.236,9.236,0,0,0,3.08-2.667,7.524,7.524,0,0,0,1.844-4.586,5.417,5.417,0,0,0-.2-1.444l.409,0a27.232,27.232,0,0,1,4.467.342,3.6,3.6,0,0,1,1.4.6L4.12,17.757a3.6,3.6,0,0,1-.6-1.4,27.246,27.246,0,0,1-.342-4.465c0-.142,0-.283,0-.424Zm12.369,7.987a27.222,27.222,0,0,1-4.465.342,27.232,27.232,0,0,1-4.467-.342,3.593,3.593,0,0,1-1.377-.58l5.845-5.845,5.844,5.844a3.59,3.59,0,0,1-1.38.582Zm3.1-3.1a3.6,3.6,0,0,1-.594,1.4l-5.846-5.846,5.86-5.86a3.591,3.591,0,0,1,.58,1.377A27.225,27.225,0,0,1,19,11.891a27.221,27.221,0,0,1-.342,4.467Z"
                    transform="translate(0 0)"
                  />
                </g>
              </svg>
              <p className="ellipsis">Sites Configuration</p>
            </span>

          </div>
        </Popover>

        <GlobalModal open={openModal} >
          {
            typeModal == "sites" ? <SiteModalContent closeModal={closeSitesConfigModal} locationName={headerData.name} locationTimeZone={headerData.timezone} locationId={headerData.id} /> : typeModal == "delete" ? <section className="deleteLocation-cont">
              <h3>Are you sure you want to delete this location?</h3>
              <div className="deleteLocation-data-p-cont">
                <p>Location : <span>{headerData?.name ? headerData?.name : iataSelected?.name ? iataSelected.name : "--"}</span></p>
                <p>IATA Code : <span>{headerData?.code ? headerData?.code : iataSelected?.standard_code ? iataSelected.standard_code : "--"}</span></p>
              </div>

              <div className="deleteLocation-btn-cont">
                <button
                  style={{
                    background: "var(--white)",
                    color: "var(--black-mid)",
                    border: "1px solid var(--black-mid)"

                  }}
                  onClick={deleteThisLocation}

                >Ok
                </button>
                <button style={{
                  background: "var(--warn)",
                  color: "var(--white)",
                }}
                  onClick={() => { setOpenModal(false) }}

                >Cancel</button>

              </div>
            </section> : null
          }
        </GlobalModal>
        <div className="expandable-configmod-previewDataCont">
          <section>
            <p style={{
              width: "10%",
              minWidth: "10%"
            }} className="ellipsis">
              <span>{iataSelected?.standard_code ? iataSelected?.standard_code : headerData?.code ? headerData?.code : "--"}</span>

            </p>
            <p style={{
              width: "33%",
              minWidth: "33%"
            }}>

              <span className="ellipsis">{iataSelected?.name ? iataSelected.name : headerData?.name ? headerData?.name : "--"}</span>

            </p>
            <p style={{
              width: "25%",
              minWidth: "25%",
            }}>
              <span className="ellipsis">{iataSelected?.timezone_id ? iataSelected.timezone_id : headerData?.timezone ? headerData?.timezone : "--"}</span>

            </p>
            <FormControlLabel
              control={
                <Checkbox
                  tabIndex={-1}

                  onClick={handleWrapperDataHubSeleceted}

                  checked={wrapperDataHubSeleceted}
                />
              }
              label={
                <p
                  className="txt-black-mid"
                  style={{
                    fontSize: ".6rem",
                    fontWeight: "500",
                  }}
                >
                  Hub
                </p>
              }
            />
          </section>
        </div>
        <div className="expandable-configmod-deleteIconCont">
          <Tooltip title="Delete Location" arrow>
            <i tabIndex={0} onClick={(e) => {
              e.stopPropagation()
              setTypeModal("delete")
              setOpenModal(true)
            }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.stopPropagation()
                  setTypeModal("delete")
                  setOpenModal(true)
                }
              }}
              style={{
                height: "1.7rem",
                width: "1.7rem",
                borderRadius: ".3rem",
                fontSize: "1rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }} className="icon-delete-new"></i>


          </Tooltip>
        </div>
      </section>
      <section
        className={`expandable-configMod-body ${isOpen ? "expandable-configMod-body-opened" : ""
          }`}
      >
        <section className="expandable-configMod-body-topData">
          {
            iata_code_data && (
              <div className="iata-code-dropdown-cont">
                <Dropdowns required={true} data={iata_code_data} onOptionSelect={getIataSelection} disabled={!editionMode} externalOpening={isNewDraft} preSelectValue={preSelectIataDrop} />
              </div>
            )
          }


          <section className="iata-info-cont">
            <p>{iataSelected ? iataSelected.name : ""}</p>
            <span>{iataSelected ? iataSelected.timezone_id : ""}</span>
          </section>
          <div
            style={{
              borderRadius: "var(--radius)",
              padding: "0.1rem",
              minWidth: "4rem",
              width: "6%",
              height: "2rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              transition: "var(--transition)",
              background: wrapperDataHubSeleceted ? "#DBFFEE" : "var(--white)",
            }}
          >
            <FormControlLabel

              control={
                <Checkbox
                  onClick={handleWrapperDataHubSeleceted}

                  checked={wrapperDataHubSeleceted}
                />
              }
              label={
                <p
                  className="txt-black-mid"
                  style={{
                    fontSize: "var(--input-font-size)",
                    fontWeight: "500",
                  }}
                >
                  Hub
                </p>
              }
            />
          </div>

          <div className="measurement-system-drop-cont">
            {systemMeasurementDrop && <Dropdowns preSelectValue={preselectIntlSystemOfOmeasurement} showWarningModal={locationInfo?.shelves > 0 || locationInfo?.bins > 0} isStatic={true} staticData={systemOfMeasurementOptions} staticDataColumnPreselection={"type"} onOptionSelect={getSystemMeasurementSelection} disabled={!editionMode} data={systemMeasurementDrop}></Dropdowns>}
          </div>

          {
            editionMode == false ?
              <button id="btn-edit-location" onClick={() => {
                seteditionMode(true)
                saveInDraft()
              }} style={{
                minWidth: "3.6rem",
                width: "7%",
                border: "1px solid var(--black-mid)",
                borderRadius: "var(--button-radius)",
                background: "var(--white)",
                color: "var(--black-mid)",
                fontSize: "var(--input-font-size)",
                fontWeight: "400",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: ".3rem",
                transition: "var(--transition)",
                height: "var(--input-height)"
              }}>
                <i className="icon-edit" style={{
                  fontSize: ".9rem"
                }}></i> Edit</button>
              : <MultioptionButton buttons={multiOptionsBtn} buttonCallbacks={buttonsCallback}></MultioptionButton>
          }


        </section>

        <section className="expandable-configMod-body-contactInfo">
          <h2>Contact Info</h2>
          <AccordionComponent
            title="Station"
            style="location-configuration"
            changeOpen={true}
          >
            <div className="station-data-cont">

              <form onSubmit={(e) => e.preventDefault()}>
                <section>
                  {/* <span > */}
                  <Input
                    disabled={!editionMode}
                    disableAutocomplete={true}
                    label="*Street 1" name="Street 1"
                    value={street1}
                    onChange={(value) => {
                      setStreet1(value.target.value)
                      deleteErrorInForm("street1")

                    }}
                    upperCase={true}
                    error={formErrors.some((e) => e == "street1") ? true : false}
                  />


                  <Input disabled={!editionMode} disableAutocomplete={true}
                    upperCase={true}
                    name="street 2" label="Street 2" value={street2} onChange={(value) => { setStreet2(value.target.value) }} />
                </section>
                <section>
                  {

                    countryDropdown && (
                      <section>
                        <Dropdowns activateErrorHint={formErrors.some((e) => e === "preselectCountry")} onOptionSelect={handleCountryDropSelected} preSelectValue={preSelectCountryDrop} disabled={!editionMode} required={true} data={countryDropdown} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload}></Dropdowns>
                      </section>
                    )
                  }
                  {

                    stateDropdown && (
                      <section>
                        <Dropdowns activateErrorHint={formErrors.some((e) => e == "preselectState")} onOptionSelect={handleStateDropSelected} preSelectValue={preSelectStateDrop} disabled={!editionMode} required={true} data={stateDropdown} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} ></Dropdowns>
                      </section>
                    )
                  }
                  {

                    cityDropdown && (
                      <section>
                        <Dropdowns activateErrorHint={formErrors.some((e) => e == "preselectCity")} onOptionSelect={handleCityDropSelected} preSelectValue={preSelectCityDrop} disabled={!editionMode} required={true} data={cityDropdown} updateDropdown={updateDropdown} resetDropdownsReload={resetDropdownsReload} ></Dropdowns>
                      </section>
                    )
                  }
                  {/* <span> */}

                  <Input
                    disabled={!editionMode}
                    disableAutocomplete={true}
                    label="*Postal code"
                    name="postalCode"
                    value={postalCode}
                    onChange={(value) => {
                      setPostalCode(value.target.value)
                      deleteErrorInForm("postalCode")

                    }}
                    upperCase={true}
                    error={formErrors.some((e) => e == "postalCode") ? true : false}
                  />

                  {/* </span> */}
                  <span>
                    {
                      isOpen && (
                        <PhoneInput
                          key={countryCodeSelected}
                          defaultCountry={countryCodeSelected}
                          placeholder="Phone"
                          value={stationPhone}
                          onChange={(value) => setStationPhone(value)}
                          disabled={!editionMode}
                          className={`${!editionMode ? "phone-input-disabled" : ""}`}
                        />

                      )
                    }

                  </span>

                  <Input disabled={!editionMode}
                    disableAutocomplete={true}
                    label="Email"
                    name="email"
                    value={email}
                    onChange={(value) => {
                      setEmail(value.target.value)
                      deleteErrorInForm("email")
                    }}
                    error={formErrors.some((e) => e == "email") ? true : false}
                    upperCase={true}
                  />


                </section>
              </form>

            </div>
          </AccordionComponent>
          <AccordionComponent
            title="Finance & Billing"
            style="location-configuration"
            changeOpen={false}
          >
            <div className="station-data-cont">

              <form onSubmit={(e) => e.preventDefault()}>
                <section>
                  <Input
                    disableAutocomplete={true}
                    disabled={!editionMode}
                    name="street 1 finance"
                    label="*Street 1"
                    value={street1Finance}
                    onChange={(value) => {
                      setStreet1Finance(value.target.value);
                      deleteErrorInForm("street1 finance")

                    }}
                    upperCase={true}
                    error={formErrors.some((e) => e == "street1 finance") ? true : false}
                  />

                  <Input
                    upperCase={true}
                    disabled={!editionMode}
                    name="street 2 finance"
                    label="Street 2"
                    value={street2Finance}
                    onChange={(value) => {
                      setStreet2Finance(value.target.value);
                    }}
                    disableAutocomplete={true}
                  />
                </section>
                <section>
                  {countryDropdown && (
                    <section>
                      <Dropdowns
                        activateErrorHint={formErrors.some((e) => e == "preselectCountry finance")}
                        onOptionSelect={handleCountryDropSelectedFinance}
                        preSelectValue={preSelectCountryDropFinance}
                        disabled={!editionMode}
                        required={true}
                        data={countryDropdown}
                        updateDropdown={updateDropdownFinance}
                        resetDropdownsReload={resetDropdownsReloadFinance}
                        clearWhenChange={true}
                      />
                    </section>
                  )}
                  {stateDropdown && (
                    <section>
                      <Dropdowns
                        activateErrorHint={formErrors.some((e) => e == "preselectState finance")}
                        onOptionSelect={handleStateDropSelectedFinance}
                        preSelectValue={preSelectStateDropFinance}
                        disabled={!editionMode}
                        required={true}
                        data={stateDropdown}
                        updateDropdown={updateDropdownFinance}
                        resetDropdownsReload={resetDropdownsReloadFinance}
                        clearWhenChange={true}
                      />
                    </section>
                  )}
                  {cityDropdown && (
                    <section>
                      <Dropdowns
                        activateErrorHint={formErrors.some((e) => e == "preselectCity finance")}
                        onOptionSelect={handleCityDropSelectedFinance}
                        preSelectValue={preSelectCityDropFinance}
                        disabled={!editionMode}
                        required={true}
                        data={cityDropdown}
                        updateDropdown={updateDropdownFinance}
                        resetDropdownsReload={resetDropdownsReloadFinance}
                        clearWhenChange={true}
                      />
                    </section>
                  )}
                  {/* <span> */}
                  <Input
                    upperCase={true}
                    disableAutocomplete={true}
                    disabled={!editionMode}
                    label="*Postal code"
                    name="postalCode finance"
                    value={postalCodeFinance}
                    onChange={(value) => {
                      setPostalCodeFinance(value.target.value);
                      deleteErrorInForm("postalCode finance")

                    }}

                    error={formErrors.some((e) => e == "postalCode finance") ? true : false}
                  />
                  {/* </span> */}
                  <span>
                    {isOpen && (
                      <PhoneInput
                        disabled={!editionMode}
                        key={countryCodeSelected}
                        defaultCountry={countryCodeSelected}
                        placeholder="Phone"
                        value={financePhone}
                        onChange={(value) => {
                          setFinancePhone(value);
                        }}
                        className={`${!editionMode ? "phone-input-disabled" : ""}`}
                      />
                    )}
                  </span>
                  <Input
                    upperCase={true}
                    disabled={!editionMode}
                    disableAutocomplete={true}
                    error={formErrors.some((e) => e == "email finance") ? true : false}
                    label="Email"
                    name="email finance"
                    value={emailFinance}
                    onChange={(value) => {
                      setEmailFinance(value.target.value);
                      deleteErrorInForm("email finance")

                    }}
                  />
                </section>
              </form>

            </div>
          </AccordionComponent>
          <AccordionComponent
            title="AOG Request"
            style="location-configuration"
            changeOpen={false}
          >
            <div className="station-data-cont">

              <form onSubmit={(e) => e.preventDefault()}>
                <section>
                  <Input
                    upperCase={true}
                    disabled={!editionMode}
                    name="street 1 AOG"
                    label="*Street 1"
                    value={street1AOG}
                    onChange={(value) => {
                      setStreet1AOG(value.target.value);
                      deleteErrorInForm("street1 AOG")
                    }}
                    disableAutocomplete={true}
                    error={formErrors.some((e) => e == "street1 AOG") ? true : false}
                  />

                  <Input
                    upperCase={true}
                    disabled={!editionMode}
                    name="street 2 AOG"
                    label="Street 2"
                    value={street2AOG}
                    onChange={(value) => {
                      setStreet2AOG(value.target.value);
                    }}
                    disableAutocomplete={true}
                    error={formErrors.some((e) => e == "street2 AOG") ? true : false}
                  />
                </section>
                <section>
                  {countryDropdown && (
                    <section>
                      <Dropdowns
                        onOptionSelect={handleCountryDropSelectedAOG}
                        preSelectValue={preSelectCountryDropAOG}
                        disabled={!editionMode}
                        required={true}
                        data={countryDropdown}
                        updateDropdown={updateDropdownAOG}
                        resetDropdownsReload={resetDropdownsReloadAOG}
                        clearWhenChange={true}
                        activateErrorHint={formErrors.some((e) => e == "preselectCountry AOG")}
                      ></Dropdowns>
                    </section>
                  )}
                  {stateDropdown && (
                    <section>
                      <Dropdowns
                        onOptionSelect={handleStateDropSelectedAOG}
                        preSelectValue={preSelectStateDropAOG}
                        disabled={!editionMode}
                        required={true}
                        data={stateDropdown}
                        updateDropdown={updateDropdownAOG}
                        resetDropdownsReload={resetDropdownsReloadAOG}
                        clearWhenChange={true}
                        activateErrorHint={formErrors.some((e) => e == "preselectState AOG")}

                      ></Dropdowns>
                    </section>
                  )}
                  {cityDropdown && (
                    <section>
                      <Dropdowns
                        onOptionSelect={handleCityDropSelectedAOG}
                        preSelectValue={preSelectCityDropAOG}
                        disabled={!editionMode}
                        required={true}
                        data={cityDropdown}
                        updateDropdown={updateDropdownAOG}
                        resetDropdownsReload={resetDropdownsReloadAOG}
                        clearWhenChange={true}
                        activateErrorHint={formErrors.some((e) => e == "preselectCity AOG")}

                      ></Dropdowns>
                    </section>
                  )}
                  <Input
                    upperCase={true}
                    disabled={!editionMode}
                    label="*Postal code"
                    name="postalCode AOG"
                    value={postalCodeAOG}
                    onChange={(value) => {
                      setPostalCodeAOG(value.target.value);
                      deleteErrorInForm("postalCode AOG")
                    }}
                    disableAutocomplete={true}
                    error={formErrors.some((e) => e == "postalCode AOG") ? true : false}
                  />
                  <span>
                    {isOpen && (
                      <PhoneInput
                        disabled={!editionMode}
                        key={countryCodeSelected}
                        defaultCountry={countryCodeSelected}
                        placeholder="Phone"
                        value={AOGPhone}
                        onChange={(value) => {
                          setAOGPhone(value);
                        }}
                        className={`${!editionMode ? "phone-input-disabled" : ""}`}
                      />
                    )}
                  </span>
                  <Input
                    upperCase={true}
                    disabled={!editionMode}
                    label="Email"
                    name="email AOG"
                    value={emailAOG}
                    onChange={(value) => {
                      setEmailAOG(value.target.value);
                      deleteErrorInForm("email AOG")
                    }}
                    disableAutocomplete={true}
                    error={formErrors.some((e) => e == "email AOG") ? true : false}
                  />
                </section>
              </form>


            </div>
          </AccordionComponent>
          <AccordionComponent
            title="Critical Request"
            style="location-configuration"
            changeOpen={false}
          >
            <div className="station-data-cont">

              <form onSubmit={(e) => e.preventDefault()} >
                <section>
                  <Input
                    upperCase={true}
                    disabled={!editionMode}
                    name="street 1 Critical"
                    label="*Street 1"
                    value={street1Critical}
                    onChange={(value) => {
                      setStreet1Critical(value.target.value);
                      deleteErrorInForm("street1 critical")
                    }}
                    disableAutocomplete={true}
                    error={formErrors.some((e) => e == "street1 critical") ? true : false}
                  />

                  <Input
                    upperCase={true}
                    disabled={!editionMode}
                    name="street 2 Critical"
                    label="Street 2"
                    value={street2Critical}
                    onChange={(value) => {
                      setStreet2Critical(value.target.value);
                    }}
                    disableAutocomplete={true}
                  />
                </section>
                <section>
                  {countryDropdown && (
                    <section>
                      <Dropdowns
                        onOptionSelect={handleCountryDropSelectedCritical}
                        preSelectValue={preSelectCountryDropCritical}
                        disabled={!editionMode}
                        required={true}
                        data={countryDropdown}
                        updateDropdown={updateDropdownCritical}
                        resetDropdownsReload={resetDropdownsReloadCritical}
                        clearWhenChange={true}
                        activateErrorHint={formErrors.some((e) => e == "preselectCountry critical")}

                      ></Dropdowns>
                    </section>
                  )}
                  {stateDropdown && (
                    <section>
                      <Dropdowns
                        onOptionSelect={handleStateDropSelectedCritical}
                        preSelectValue={preSelectStateDropCritical}
                        disabled={!editionMode}
                        required={true}
                        data={stateDropdown}
                        updateDropdown={updateDropdownCritical}
                        resetDropdownsReload={resetDropdownsReloadCritical}
                        clearWhenChange={true}
                        activateErrorHint={formErrors.some((e) => e == "preselectCity critical")}


                      ></Dropdowns>
                    </section>
                  )}
                  {cityDropdown && (
                    <section>
                      <Dropdowns
                        onOptionSelect={handleCityDropSelectedCritical}
                        preSelectValue={preSelectCityDropCritical}
                        disabled={!editionMode}
                        required={true}
                        data={cityDropdown}
                        updateDropdown={updateDropdownCritical}
                        resetDropdownsReload={resetDropdownsReloadCritical}
                        clearWhenChange={true}
                        activateErrorHint={formErrors.some((e) => e == "preselectCity critical")}

                      ></Dropdowns>
                    </section>
                  )}
                  <Input
                    upperCase={true}
                    disableAutocomplete={true}
                    disabled={!editionMode}
                    label="*Postal code"
                    name="postalCode Critical"
                    value={postalCodeCritical}
                    onChange={(value) => {
                      setPostalCodeCritical(value.target.value);
                      deleteErrorInForm("postalCode critical")

                    }}
                    error={formErrors.some((e) => e == "postalCode critical") ? true : false}

                  />
                  <span>
                    {isOpen && (
                      <PhoneInput
                        disabled={!editionMode}
                        key={countryCodeSelected}
                        defaultCountry={countryCodeSelected}
                        placeholder="Phone"
                        value={CriticalPhone}
                        onChange={(value) => {
                          setCriticalPhone(value);
                        }}
                        className={`${!editionMode ? "phone-input-disabled" : ""}`}
                      />
                    )}
                  </span>
                  <Input
                    upperCase={true}
                    disabled={!editionMode}
                    disableAutocomplete={true}
                    label="Email"
                    name="email Critical"
                    value={emailCritical}
                    onChange={(value) => {
                      setEmailCritical(value.target.value);
                      deleteErrorInForm("email critical")

                    }}
                    error={formErrors.some((e) => e == "email critical") ? true : false}

                  />

                </section>
              </form>



            </div>
          </AccordionComponent>
          <AccordionComponent
            title="Warehouse"
            style="location-configuration"
            changeOpen={false}
          >
            <div className="station-data-cont">

              <form onSubmit={(e) => e.preventDefault()} >
                <section>
                  <Input
                    upperCase={true}
                    disabled={!editionMode}
                    disableAutocomplete={true}
                    label="street 1"
                    placeholder="*Street 1"
                    value={street1whareHouse}
                    onChange={(value) => {
                      setStreet1whareHouse(value.target.value);
                      deleteErrorInForm("street1 wharehouse")

                    }}
                    error={formErrors.some((e) => e == "street1 wharehouse") ? true : false}
                    name="street 1 whareHouse"
                  />

                  <Input
                    upperCase={true}
                    disabled={!editionMode}
                    name="street 2 whareHouse"
                    disableAutocomplete={true}
                    label="Street 2"
                    value={street2whareHouse}
                    onChange={(value) => {
                      setStreet2whareHouse(value.target.value);
                    }}
                  />
                </section>
                <section>
                  {countryDropdown && (
                    <section>
                      <Dropdowns
                        onOptionSelect={handleCountryDropSelectedwhareHouse}
                        preSelectValue={preSelectCountryDropwhareHouse}
                        disabled={!editionMode}
                        required={true}
                        data={countryDropdown}
                        updateDropdown={updateDropdownWhareHouse}
                        resetDropdownsReload={resetDropdownsReloadWharehouse}
                        clearWhenChange={true}
                        activateErrorHint={formErrors.some((e) => e == "preselectCountry wharehouse")}
                      ></Dropdowns>
                    </section>
                  )}
                  {stateDropdown && (
                    <section>
                      <Dropdowns
                        onOptionSelect={handleStateDropSelectedwhareHouse}
                        preSelectValue={preSelectStateDropwhareHouse}
                        disabled={!editionMode}
                        required={true}
                        data={stateDropdown}
                        updateDropdown={updateDropdownWhareHouse}
                        resetDropdownsReload={resetDropdownsReloadWharehouse}
                        clearWhenChange={true}
                        activateErrorHint={formErrors.some((e) => e == "preselectState wharehouse")}

                      ></Dropdowns>
                    </section>
                  )}
                  {cityDropdown && (
                    <section>
                      <Dropdowns
                        onOptionSelect={handleCityDropSelectedwhareHouse}
                        preSelectValue={preSelectCityDropwhareHouse}
                        disabled={!editionMode}
                        required={true}
                        data={cityDropdown}
                        updateDropdown={updateDropdownWhareHouse}
                        resetDropdownsReload={resetDropdownsReloadWharehouse}
                        clearWhenChange={true}
                        activateErrorHint={formErrors.some((e) => e == "preselectCity wharehouse")}

                      ></Dropdowns>
                    </section>
                  )}
                  <Input
                    upperCase={true}
                    disableAutocomplete={true}
                    disabled={!editionMode}
                    label="*Postal code"
                    name="postalCode whareHouse"
                    value={postalCodewhareHouse}
                    onChange={(value) => {
                      setPostalCodewhareHouse(value.target.value);
                      deleteErrorInForm("postalCode wharehouse")
                    }}

                    error={formErrors.some((e) => e == "postalCode wharehouse") ? true : false}
                  />
                  <span>
                    {isOpen && (
                      <PhoneInput
                        disabled={!editionMode}
                        key={countryCodeSelected}
                        defaultCountry={countryCodeSelected}
                        placeholder="Phone"
                        value={whareHousePhone}
                        onChange={(value) => {
                          setwhareHousePhone(value);
                        }}
                        className={`${!editionMode ? "phone-input-disabled" : ""}`}
                      />
                    )}
                  </span>
                  <Input
                    upperCase={true}
                    disableAutocomplete={true}
                    disabled={!editionMode}
                    label="Email"
                    name="email whareHouse"
                    value={emailwhareHouse}
                    onChange={(value) => {
                      setEmailwhareHouse(value.target.value);
                      deleteErrorInForm("email wharehouse")
                    }}

                    error={formErrors.some((e) => e == "email wharehouse") ? true : false}
                  />
                </section>
              </form>



            </div>
          </AccordionComponent>
        </section>
      </section>

    </>
  );
};
